module.exports = __webpack_public_path__ + "static/media/20171020_111018.c7ad97b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20171020_111018.jpg
// module id = 470
// module chunks = 0